import React from "react";
import { Button, Wrapper } from "@networkraildigitalfactory/components";

const ActionButtons = (props) => {
  const {
    status,
    isLineManager,
    toggleAreYouSureModal,
    toggleInputModal,
    goToEditView,
    type,
  } = props;
  const actionFor = type === "PDP" ? "development goal" : "objective";
  switch (status) {
    case "pending approval":
      return (
        <div
          style={{
            display: "flex",
            justifyContent: isLineManager ? "space-between" : "space-between",
            padding: " 24px 5vw",
          }}
        >
          <Button
            color="red"
            text={isLineManager ? "Reject" : `Cancel ${actionFor}`}
            name={isLineManager ? "reject" : `cancel ${actionFor}`}
            onClick={() => {
              toggleInputModal(isLineManager ? "RejectObjective" : "Cancel");
            }}
            id={isLineManager ? "rejectBtn" : "cancelObjectiveBtn"}
          />
          <Button
            color="blue"
            text={isLineManager ? "Approve" : "Edit"}
            name={isLineManager ? "approve" : "edit"}
            onClick={
              isLineManager
                ? () => {
                    toggleAreYouSureModal("Approve");
                  }
                : goToEditView
            }
            style={{ marginLeft: isLineManager ? "2rem" : 0 }}
            id={isLineManager ? "approveBtn" : "editBtn"}
          />
        </div>
      );
    case "review required":
      return (
        <div
          style={{
            display: "flex",
            padding: "30px 0 30px 70px",
            justifyContent: isLineManager ? "flex-start" : "space-between",
          }}
        >
          <Button
            color="red"
            text={`Cancel ${actionFor}`}
            name={`cancel ${actionFor}`}
            onClick={() => {
              toggleInputModal(isLineManager ? "LMCancel" : "Cancel");
            }}
            id={isLineManager ? "lmCancelBtn" : "cancelObjectiveBtn"}
          />
          {!isLineManager && <Button color="blue" text="Edit" name="edit" onClick={goToEditView} />}
        </div>
      );
    case "approved":
      return (
        <Wrapper maxWidth={1180} align="center">
          <div
            style={{ display: "flex", justifyContent: isLineManager ? "start" : "space-between" }}
          >
            <Button
              color="red"
              text={`Cancel ${actionFor}`}
              name={`cancel ${actionFor}`}
              onClick={() => {
                toggleInputModal(isLineManager ? "LMCancel" : "Cancel");
              }}
              id={isLineManager ? "lmCancelBtn" : "cancelObjectiveBtn"}
            />
            {!isLineManager && (
              <div style={{ display: "flex" }}>
                <Button color="blue" text="Edit" name="edit" onClick={goToEditView} id="editBtn" />
                <Button
                  color="green"
                  text="Mark as complete"
                  name="edit"
                  onClick={() => {
                    toggleAreYouSureModal("Completed");
                  }}
                  style={{ marginLeft: "2rem" }}
                  id="markCompleteBtn"
                />
              </div>
            )}
          </div>
        </Wrapper>
      );
    case "employee complete":
      return isLineManager ? (
        <Wrapper maxWidth={1180} align="center">
          <div
            style={{
              display: "flex",
              justifyContent: isLineManager ? "space-between" : "space-between",
            }}
          >
            <Button
              color="red"
              text="Reject"
              name="reject"
              onClick={() => {
                toggleInputModal("RejectCompletion");
              }}
              id="rejectBtn"
            />
            <Button
              color="blue"
              text="Complete"
              name="complete"
              onClick={() => {
                toggleAreYouSureModal("LMCompleted");
              }}
              style={{ marginLeft: "2rem" }}
              id="completeBtn"
            />
          </div>
        </Wrapper>
      ) : (
        <></>
      );
    case "cancelled":
      return <></>;
    case "completed":
      return <></>;
    default:
      return <></>;
  }
};

export default ActionButtons;
